import React from 'react';
import InteractiveLife2023 from 'views/InteractiveLife2023';

const LifeSkillPage = () => {
  return <InteractiveLife2023/>;
};

export default LifeSkillPage;
